import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';

import {ClienteModalComponent} from './cliente-modal/cliente-modal.component';
import {AjudaVariaveisComponent} from './ajuda-variaveis-modal/ajuda-variaveis-modal.component';
import {InstalacaoProdutoModalComponent} from './instalacao-produto-modal/instalacao-produto-modal.component';
import {ItemConfiguracaoModalComponent} from './item-configuracao-modal/item-configuracao-modal.component';
import {MapaLayoutModalComponent} from './mapa-layout-modal/mapa-layout-modal.component';
import {ServicoModalComponent} from './servico-modal/servico-modal.component';
import {HostnameModalComponent} from './hostname-modal/hostname-modal.component';
import {DetalheFtaModalComponent} from './detalhe-fta-modal/detalhe-fta-modal.component';
import {ResumoFtaModalComponent} from './resumo-novo-fta-modal/resumo-fta-modal.component';
import {LoginModalComponent} from './login-modal/login-modal';
import {orderByPipe} from '../pipe/order-by';
import {RoteiroModalComponent} from './roteiro-modal/roteiro-modal.component';
import {ConfirmarFtaModalComponent} from './confirmar-fta-modal/confirmar-fta-modal.component';

import {MigracaoFtaModalComponent} from './migracao-fta-modal/migracao-fta-modal.component';
import {TabViewModule} from 'primeng/components/tabview/tabview';
import {EdicaoArtefatosModalComponent} from './edicao-artefatos/edicao-artefatos-modal.component';
import {ParametroEntradaModalComponent} from './parametro-entrada-moldal/parametro-entrada-modal.component';
import { AvaliacaoModalComponent } from './avaliacao-modal/avaliacao-modal.component';

@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        TabViewModule,

    ],
    declarations: [
        ClienteModalComponent,
        AjudaVariaveisComponent,
        InstalacaoProdutoModalComponent,
        ItemConfiguracaoModalComponent,
        MapaLayoutModalComponent,
        ServicoModalComponent,
        HostnameModalComponent,
        DetalheFtaModalComponent,
        ResumoFtaModalComponent,
        orderByPipe,
        LoginModalComponent,
        RoteiroModalComponent,
        ConfirmarFtaModalComponent,
        MigracaoFtaModalComponent,
        EdicaoArtefatosModalComponent,
        ParametroEntradaModalComponent,
        AvaliacaoModalComponent,
    ],
    providers: [],
    exports: [
        ClienteModalComponent,
        InstalacaoProdutoModalComponent,
        ItemConfiguracaoModalComponent,
        MapaLayoutModalComponent,
        ServicoModalComponent,
        HostnameModalComponent,
        DetalheFtaModalComponent,
        ResumoFtaModalComponent,
        LoginModalComponent,
        RoteiroModalComponent,
        ConfirmarFtaModalComponent,
        MigracaoFtaModalComponent,
        EdicaoArtefatosModalComponent,
        ParametroEntradaModalComponent
    ]
})
export class ModalModule {
}



// WEBPACK FOOTER //
// ./src/app/modal/modal.module.ts